import { useParams } from 'react-router';

import { Grid } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers-pro/AdapterDateFns';
import { ptBR } from 'date-fns/locale';
import { getIn, useFormikContext } from 'formik';

import { CissNumberField } from 'components/fields';
import { Row } from 'components/form';
import { Block } from 'components/page';
import { GrupoExibicaoAutoComplete } from 'pages/complementar/banda-preco/components';
import { BandaPreco } from 'pages/complementar/banda-preco/types';

export function BandaPrecoGeneralBlock() {
    const { id } = useParams();
    const { errors, setFieldValue, values } = useFormikContext<BandaPreco>();

    return (
        <Block>
            <Row>
                <Grid sx={{ flex: 1 }}>
                    <GrupoExibicaoAutoComplete
                        name="dreMercadologicaGrupoExibicao"
                        disabled={Boolean(id)}
                        value={values.dreMercadologicaGrupoExibicao}
                        error={getIn(errors, 'dreMercadologicaGrupoExibicao')}
                        onChange={(e, value) => setFieldValue('dreMercadologicaGrupoExibicao', value)}
                    />
                </Grid>

                <Grid sx={{ flex: 1 }}>
                    <CissNumberField
                        label="Banda de preço (%)"
                        name="peBandaPreco"
                        inputType="decimal"
                        maxValue={100}
                        value={values.peBandaPreco}
                        error={errors.peBandaPreco}
                        onChange={(e) => setFieldValue('peBandaPreco', e.target.value)}
                    />
                </Grid>

                <Grid sx={{ flex: 1 }}>
                    <LocalizationProvider adapterLocale={ptBR} dateAdapter={AdapterDateFns}>
                        <DatePicker
                            label="Data de vigência"
                            format="dd/MM/yyyy"
                            sx={{ width: '100%' }}
                            value={values.dtInicioVigencia ? new Date(values.dtInicioVigencia) : null}
                            onChange={(value) => setFieldValue('dtInicioVigencia', value)}
                            slotProps={{
                                textField: {
                                    error: Boolean(errors.dtInicioVigencia),
                                    helperText: errors.dtInicioVigencia,
                                },
                            }}
                        />
                    </LocalizationProvider>
                </Grid>
            </Row>
        </Block>
    );
}
